import React from "react";

function AuthorPage() {
  return (
    <div className="author-page" style={{ maxWidth: 800, margin: "0 auto", padding: "2rem" }}>
      <h1>Founder Story</h1>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "1.5rem" }}>
        <img
          src="https://secure.gravatar.com/avatar/8eeecf171388b363e436fa075db30e0aa0002250608d7618d125302de34319ff?s=60&d=identicon&r=g"
          alt="Cristina Trujillo Avatar"
          style={{ borderRadius: "50%", width: 60, height: 60, marginRight: 16 }}
        />
        <div>
          <strong>Cristina Trujillo</strong>
          <div style={{ fontSize: "0.9em", color: "#666" }}>December 19, 2013</div>
        </div>
      </div>
      <section style={{ marginBottom: "2rem" }}>
        <p>Hi, my name is Cristina Trujillo and I am a single mom of two beautiful children. I am a blogger, writer, and mother who is passionate about sharing my experiences and insights with other single moms and families.</p>
      </section>
      <section style={{ marginBottom: "2rem" }}>
        <h2>My Journey as a Single Mom</h2>
        <p>As a single mom, I understand the unique challenges and rewards that come with raising children on your own. I am committed to providing practical advice, resources, and support to help other single moms navigate their journey with confidence and grace.</p>
        <p>My blog, Mom and Baby Healthy Living, is a space where I share my thoughts, experiences, and advice on a wide range of topics related to motherhood. The core focus is on healthy living, knowing what is in your foods, and making informed choices for your family.</p>
        <p>When I'm not blogging, I enjoy spending time with my kids, hiking in the mountains, and exploring new hobbies. I am also an avid traveler and love to travel the USA with my children. I believe that travel is a great way to broaden our horizons and create unforgettable memories with our families.</p>
      </section>
      <section style={{ marginBottom: "2rem" }}>
        <h2>My Goals and Vision</h2>
        <p>My goal is to be a stay-at-home mom and raise my children in a safe and loving environment. I believe that every child deserves the best possible start in life, and I am committed to providing that for my kids.</p>
        <p>Additionally, I am passionate about empowering other single moms to navigate their journey with confidence and grace. I aim to provide practical advice, resources, and support to help other single moms thrive and make the most of their time with their children.</p>
        <p>My vision is to create a community of single moms who support and inspire each other. I want to provide a space where we can share our experiences, learn from each other, and grow together.</p>
      </section>
      <section style={{ marginBottom: "2rem" }}>
        <h2>My Blog and Resources</h2>
        <p>My blog, , is a space where I share my thoughts, experiences, and advice on a wide range of topics related to single motherhood. From budgeting and time management to self-care and family relationships, I aim to provide valuable insights and practical tips to help other single moms thrive.</p>

        <p>I am committed to providing valuable and practical resources to help single moms navigate their journey with confidence and grace. I hope that my blog and resources will inspire and empower you on your journey as a single mom.</p>
      </section>
      <section style={{ marginBottom: "2rem" }}>
        <p>Thank you for visiting my blog. I hope that my stories and advice will inspire and empower you on your journey as a single mom. If you have any questions or would like to connect, please feel free to reach out to me.</p>
      </section>
    </div>
  );
}

export default AuthorPage;
